import { FC } from 'react';
import { Button } from '../../Button';
import { ButtonVariant } from '../../buttonHelper';
import { InputProps, withField } from '../withField';

interface YesNoProps {
  id?: string;
  onChange?: (newValue: boolean) => void;
}

const YesNoInput: FC<InputProps<boolean> & YesNoProps> = ({ id, value, onChange }) => {
  return (
    <label className="flex items-center cursor-pointer">
      <div className="flex space-x-2">
        <input id={id} checked={value} readOnly type="checkbox" className="sr-only" />
        <Button
          onClick={() => {
            onChange(true);
          }}
          variant={value ? ButtonVariant.Primary : ButtonVariant.Mono}
        >
          Yes
        </Button>
        <Button
          onClick={() => {
            onChange(false);
          }}
          variant={!value ? ButtonVariant.Primary : ButtonVariant.Mono}
        >
          No
        </Button>
      </div>
    </label>
  );
};

export const YesNoField = withField<boolean, YesNoProps>(YesNoInput);
